// export interface Route {
//   title: string;
//   url: string;
// }

// interface Routes {
//   [key: string]: Route;
// }

const routes = {
  HOME: {
    title: 'Home',
    url: '/',
  },

  INVEST: {
    title: 'Invest',
    url: '/invest',
  },

  EXPLORE: {
    title: 'Explore',
    url: '/explore',
  },

  INVESTMENT_IDEAS: {
    title: 'Investment Ideas',
    url: '/investmentIdeas',
  },

  PORTFOLIO: {
    title: 'Portfolio',
    url: '/portfolio',
  },

  FAQ: {
    title: 'FAQs',
    url: '/faq',
  },

  FAQ_TYPE: {
    title: 'FAQ TYPE',
    url: '/faq/[faqType]',
  },

  PLAN_SIP: {
    title: 'Plan SIP',
    url: '/planSIP',
  },

  INSTA_SIP: {
    title: 'Insta SIP',
    url: 'explore/Equity?isSip=true&route=instasip',
  },

  EXPLORE_FUND: {
    title: 'Explore Funds',
    url: '/explore/[fundType]',
  },

  HOLDINGS: {
    title: 'Holdings',
    url: '/portfolio/holdings',
  },

  TRANSACTION: {
    title: 'Transactions',
    url: '/portfolio/transactions',
  },

  STATEMENTS: {
    title: 'Statements',
    url: '/portfolio/statements',
  },

  SCHEME_DETAIL: {
    title: 'Scheme Details',
    url: '/explore/detail',
  },

  AXIS_SELECT: {
    title: 'Axis Select Funds',
    url: '/explore/axisSelectFunds',
  },

  MUTUAL_FUND: {
    title: 'Mutual Funds',
    url: '/mutualFunds',
  },

  NFO: {
    title: 'New Fund Offering',
    url: '/newFundOffering',
  },

  NFOBANNER: {
    title: 'New Fund Offering',
    url: '/newFundOffering?fundCode=CK1197',
  },

  UTI: {
    title: 'UTI NFO',
    url: '/newFundOffering?fundCode=K108FBGP',
  },

  PROFILE: {
    title: 'Profile',
    url: '/portfolio/profile',
  },
  LOGIN: {
    title: 'Login',
    url: '/login',
  },
  LOGOUT: {
    title: 'Logout',
    url: '/logout',
  },
  SESSION_EXPIRED: {
    title: 'Session Expired',
    url: '/sessionExpired',
  },
  TRANSACT_INVEST: {
    title: 'Invest',
    url: '/transact/invest',
  },
  SWITCH: {
    title: 'Switch',
    url: '/transact/switch',
  },

  REDEEM: {
    title: 'Redeem',
    url: '/transact/redeem',
  },

  RISK_PROFILE: {
    title: 'Risk Profile',
    url: '/riskProfile',
  },

  GOAL_SETTING: {
    title: 'Goal Setting',
    url: '/goalSetting',
  },

  KYC: {
    title: 'KYC',
    url: '/kyc',
  },

  KYC_ERROR: {
    title: 'Kyc Error',
    url: '/kyc/error',
  },

  INSIGHTS: {
    title: 'Insights',
    url: '/portfolio/insights',
  },
  CART: {
    title: 'Cart',
    url: '/cart',
  },
  FUNDS_WITH_MODERATE_TO_HIGH_RETURNS: {
    title: 'Funds with Moderate to High Returns',
    url: '/explore/fundsWithModerateToHighReturns',
  },
  LARGE_CAP: {
    title: 'LargeCap Section in mutual funds',
    url: 'explore/EQ?subCategory=ELF&isSip=false',
  },
  MULTI_CAP: {
    title: 'MultiCap Section in mutual funds',
    url: 'explore/EQ?subCategory=EFC&isSip=false',
  },
  HYBRID_FUNDS: {
    title: 'Hybrid Funds',
    url: '/explore/Hybrid',
  },
  EQUITY_FUNDS_LARGE_CAP: {
    title: 'Large cap',
    url: '/explore/Equity',
  },
  GOLD_FUNDS: {
    title: 'Gold Funds',
    url: 'explore/OTH,SOS?subCategory=GOLD&isSip=false',
  },
  EXPLORE_NFO: {
    title: 'Explore NFO',
    url: '/explore/NFO',
  },
  CIB: {
    title: 'CIB Page',
    url: '/portfolioCIB',
  },

  // Add routes here for each Page
};

export { routes };
